/**
 * Constantes centralizadas para tipos de perfil de usuário
 * Utilizadas em AccountSettings e ProfileUpdateModal
 */

export const PROFILE_TYPES = {
  PROFESSIONAL: "professional",
  PATIENT: "patient",
  PERSONAL: "personal",
};

export const PROFILE_OPTIONS = [
  {
    key: PROFILE_TYPES.PROFESSIONAL,
    title: "Sou Profissional",
    description: "Uso no atendimento de pacientes",
    menuLabel: "Sou profissional",
  },
  {
    key: PROFILE_TYPES.PATIENT,
    title: "Sou Paciente",
    description: "Uso como paciente em acompanhamento",
    menuLabel: "Sou paciente",
  },
  {
    key: PROFILE_TYPES.PERSONAL,
    title: "Uso pessoal",
    description: "Vou praticar sem acompanhamento profissional",
    menuLabel: "Uso para mim",
  },
];

/**
 * Retorna o label do perfil baseado na chave
 * @param {string} profileKey - Chave do perfil (professional, patient, personal)
 * @returns {string} Label do perfil para exibição
 */
export const getProfileLabel = (profileKey) => {
  const normalizedKey = profileKey?.toLowerCase();
  const profile = PROFILE_OPTIONS.find((p) => p.key === normalizedKey);
  return profile?.title || "Paciente";
};

/**
 * Retorna a opção de perfil completa baseada na chave
 * @param {string} profileKey - Chave do perfil
 * @returns {Object|null} Objeto com dados do perfil ou null
 */
export const getProfileOption = (profileKey) => {
  const normalizedKey = profileKey?.toLowerCase();
  return PROFILE_OPTIONS.find((p) => p.key === normalizedKey) || null;
};
